// extracted by mini-css-extract-plugin
export default {"title":"tableTitle_title__XBBEI"};